// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Invoice_MainSelect___WRFw {\n  width: 250px;\n  margin-bottom: 20px;\n}", "",{"version":3,"sources":["webpack://src/pages/tables/Invoice.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;AACF","sourcesContent":[".MainSelect {\n  width: 250px;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"MainSelect": "Invoice_MainSelect___WRFw"
};
export default ___CSS_LOADER_EXPORT___;
